import React, { useEffect, useState } from 'react';
import ProjectionsTeamsTable from '../ProjectionsTeamsTable/ProjectionsTeamsTable';
import ProjectionsByPositionTable from '../ProjectionsByPositionTable/ProjectionsByPositionTable';

const POSITION_OPTIONS = [
	'QB',
	'RB',
	'WR',
	'TE'
];

export default function ProjectionsIndexCard({
	get_projection_teams_endpoint,
	get_projection_players_endpoint
}) {
	const viewModeButtonBaseClasses =
		'px-4 py-2 rounded-lg transition-colors duration-150 border';
	const viewModeButtonClasses = (isActive) =>
		`${viewModeButtonBaseClasses} ${isActive
			? 'bg-blue-500 hover:bg-blue-600 text-white border-blue-500'
			: 'bg-white dark:bg-dark-card text-gray-700 dark:text-dark-text border-gray-300 dark:border-dark-border hover:bg-gray-50 dark:hover:bg-dark-bg'}`;

	const [
		viewMode,
		setViewMode
	] = useState('teams');
	const [
		position,
		setPosition
	] = useState('QB');
	const [
		teams,
		setTeams
	] = useState([]);
	const [
		players,
		setPlayers
	] = useState([]);
	const [
		loading,
		setLoading
	] = useState(true);

	useEffect(
		() => {
			if (viewMode === 'teams') {
				fetchTeams();
			} else {
				fetchPlayers(position);
			}
		},
		[
			viewMode,
			position
		]
	);

	const fetchTeams = async () => {
		setLoading(true);
		try {
			const response = await fetch(get_projection_teams_endpoint);
			const result = await response.json();
			setTeams(result.data || []);
		} catch (error) {
			console.error('Error fetching projection teams:', error);
		} finally {
			setLoading(false);
		}
	};

	const fetchPlayers = async (positionCode) => {
		setLoading(true);
		try {
			const response = await fetch(
				`${get_projection_players_endpoint}?position=${positionCode}`
			);
			const result = await response.json();
			setPlayers(result.data || []);
		} catch (error) {
			console.error('Error fetching projection players:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="p-6 lg:p-8 border border-gray-300 dark:border-dark-border rounded-xl shadow-lg bg-white dark:bg-dark-card text-gray-800 dark:text-dark-text">
			<div className="flex items-center justify-between mb-4 flex-wrap gap-2">
				<div className="flex items-center gap-2">
					<button
						className={viewModeButtonClasses(viewMode === 'teams')}
						onClick={() => setViewMode('teams')}
					>
						Teams
					</button>
					<button
						className={viewModeButtonClasses(viewMode === 'position')}
						onClick={() => setViewMode('position')}
					>
						By Position
					</button>
				</div>
				{viewMode === 'position' && (
					<div className="flex items-center gap-2">
						{POSITION_OPTIONS.map((option) => (
							<button
								key={option}
								className={`px-4 py-2 rounded-lg border ${position === option
									? 'bg-gray-800 text-white border-gray-800'
									: 'bg-white dark:bg-dark-card text-gray-700 dark:text-dark-text border-gray-300 dark:border-dark-border'}`}
								onClick={() => setPosition(option)}
							>
								{option}
							</button>
						))}
					</div>
				)}
			</div>

			{loading && <div className="text-gray-600 dark:text-gray-300">Loading projections...</div>}

			{!loading &&
			viewMode === 'teams' && <ProjectionsTeamsTable teams={teams} />}
			{!loading &&
			viewMode === 'position' && (
				<ProjectionsByPositionTable players={players} position={position} />
			)}
		</div>
	);
}
